import React, { useMemo, useState } from "react"
import SButton from "components/Common/Button"
import { useHistory } from "react-router-dom"
import TableContainer from "components/newTables/TableContainer"

const Table = ({ content, refetch, page, size, count, setParams, params }) => {
  const history = useHistory()

  const listDataTable = useMemo(() => {
    if (!content) return []
    return content.map((v, i) => ({
      id: v.id,
      name: v.name,
      manager: v.manager,
      phone: v.phone,
      emailTo: v.emailTo,
      orderingMethod: v.orderingMethod,
      outOfStockDeliveries: v.outOfStockDeliveries,
    }))
  }, [content])

  const columns = useMemo(
    () => [
      {
        Header: "商社名",
        accessor: "name",
        disableSortBy: true,
      },
      {
        Header: "担当者",
        accessor: "manager",
        disableSortBy: true,
      },
      {
        Header: "メールアドレス",
        accessor: "emailTo",
        disableSortBy: true,
      },
      {
        Header: "電話番号",
        accessor: "phone",
        disableSortBy: true,
      },
      {
        Header: "発注方式",
        accessor: "orderingMethod",
        disableSortBy: true,
      },
      {
        Header: "品切れ配信",
        accessor: "outOfStockDeliveries",
        disableSortBy: true,
        Cell: props => {
          return <div>{props.row.values.outOfStockDeliveries.join(", ")}</div>
        },
      },
      {
        Header: "",
        accessor: "action",
        disableSortBy: true,
        Cell: cell => {
          return (
            <SButton
              className="button"
              onClick={() =>
                history.push(
                  `/master/fabric-trading-company/${cell.row.original.id}`
                )
              }
            >
              詳細
            </SButton>
          )
        },
      },
    ],
    []
  )

  return content?.length === 0 ? (
    <h3 className="text-center">No Data to Display</h3>
  ) : (
    <TableContainer
      columns={columns}
      data={listDataTable}
      page={page}
      size={size}
      count={count}
      setParams={setParams}
      params={params}
      pagination
    />
  )
}

export default Table
